import { recipientCountry, setFormData } from "../../../store/slicers/address";
import { setCustomPrice } from "../../../store/slicers/app";
import {
  updatePostCardList,
  updateSelectedCardsList,
} from "../../../store/slicers/template";

interface IPreOrderItem {
  id: number;
  route: string;
  action: any;
  secondAction?: any;
  actionKey: string | any;
  secondActionKey?: string;
  thirdAction?: any;
  thirdActionKey?: any;
}

export const preOrderListWithActions: Array<IPreOrderItem> = [
  {
    id: 2,
    route: "/addresses",
    action: updatePostCardList,
    actionKey: "postCardsData",
    secondAction: setCustomPrice,
    secondActionKey: "customPrice",
    thirdAction: updateSelectedCardsList,
    thirdActionKey: "selectedGiftCardIDs",
  },
  {
    id: 5,
    route: "/price",
    action: setFormData,
    actionKey: "addressData",
    secondAction: recipientCountry,
  },
];
